import * as React from 'react';

import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { imgUrl } from '~src/commonInfra/utils/ImgUrl';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';

import { Messages } from '../../../codegen/Localize';
import { classes, cssClass } from '../../../style';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';

const cssPrefix = 'PredictiveModelThumbnail';

const rootClass = cssClass(cssPrefix, 'root', {
  color: 'inherit',
  textDecoration: 'none',
  $nest: {
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    }
  }
});

const iconClass = cssClass(cssPrefix, 'icon', {
  backgroundImage: imgUrl('spaces_masthead_predictive_model.svg')
});

export interface PredictiveModelThumbnailProps extends SiteUrlsProps {
  readonly hoveredOrSelected: boolean;
  readonly navigateUrl: string;
  readonly owner: IUserInfo;
}

export class PredictiveModelThumbnail extends React.Component<PredictiveModelThumbnailProps> {

  public render() {
    const containerClass = this.props.hoveredOrSelected ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnail;
    return (
      <a className={classes(containerClass, rootClass)}
         href={this.props.navigateUrl}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={classes(CardViewStyles.CustomThumbnailImg, iconClass)} title={Messages.predictiveModel()} />
          </div>
        </div>
      </a>
    );
  }
}
